// extracted by mini-css-extract-plugin
module.exports = {"stickerList":"StickerLabels_stickerList__m5hJi","sticker":"StickerLabels_sticker__2BNEZ","stickerDot":"StickerLabels_stickerDot__wZW87"};